"use client";

import { useEffect, useState } from "react";

/**
 * Returns the current URL hash (without the leading #) and
 * updates automatically on `hashchange`.
 */
function useHashRoute(): string | null {
  const [hash, setHash] = useState<string | null>(null);

  useEffect(() => {
    const update = () => setHash(window.location.hash.slice(1) || null);

    update(); // initial value
    window.addEventListener("hashchange", update);
    return () => window.removeEventListener("hashchange", update);
  }, []);

  return hash;
}

export default useHashRoute;
